<template>
  <div class="case-list-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-section">
      <div class="breadcrumb">
        <span class="breadcrumb-item">造价案例</span>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-item">{{ selectedCategory }}</span>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-item">{{ selectedSubCategory }}</span>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-item">{{ selectedSubSubCategory }}</span>
      </div>
    </div>

    <!-- 已选条件 -->
    <div class="selected-conditions">
      <div class="condition-tag">
        <span>造价案例 {{ selectedCategory }} {{ selectedSubCategory }} {{ selectedSubSubCategory }}</span>
        <span
          class="close-icon"
          @click="clearSelection"
        >×</span>
      </div>
    </div>

    <div style="background: #fff;">
      <!-- 案例列表按钮 -->
      <div class="case-list-button">
        <button class="case-list-btn">案例列表</button>
      </div>

      <!-- 案例网格 -->
      <div class="cases-grid">
        <div
          v-for="caseItem in caseList"
          :key="caseItem.id"
          class="case-card"
          @click="viewCaseDetail(caseItem)"
        >
          <div class="case-image">
            <img
              :src="caseItem.image"
              :alt="caseItem.title"
              class="case-img"
            >
          </div>
          <div class="case-title">{{ caseItem.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaseList',
  data() {
    return {
      selectedCategory: '民用建筑',
      selectedSubCategory: '居住建筑',
      selectedSubSubCategory: '商品住宅',
      caseList: [
        {
          id: 1,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg1.png')
        },
        {
          id: 2,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg2.png')
        },
        {
          id: 3,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg3.png')
        },
        {
          id: 4,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg4.png')
        },
        {
          id: 5,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg5.png')
        },
        {
          id: 6,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg6.png')
        },
        {
          id: 7,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg1.png')
        },
        {
          id: 8,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg2.png')
        },
        {
          id: 9,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg3.png')
        },
        {
          id: 10,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg4.png')
        },
        {
          id: 11,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg5.png')
        },
        {
          id: 12,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg6.png')
        },
        {
          id: 13,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg1.png')
        },
        {
          id: 14,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg2.png')
        },
        {
          id: 15,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg3.png')
        },
        {
          id: 16,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg4.png')
        }
      ]
    }
  },
  mounted() {
    // 从路由参数获取选择的分类信息
    const { category, subCategory, subSubCategory } = this.$route.query
    if (category) {
      this.selectedCategory = this.getCategoryLabel(category)
    }
    if (subCategory) {
      this.selectedSubCategory = this.getSubCategoryLabel(category, subCategory)
    }
    if (subSubCategory) {
      this.selectedSubSubCategory = this.getSubSubCategoryLabel(category, subCategory, subSubCategory)
    }
  },
  methods: {
    getCategoryLabel(categoryValue) {
      const categoryMap = {
        civil: '民用建筑',
        municipal: '市政工程',
        road: '道路工程',
        rail: '轨道交通',
        bridge: '桥涵工程',
        tunnel: '隧道工程',
        hydraulic: '水工工程',
        power: '电力工程',
        communication: '通信土建',
        industrial: '工业建筑'
      }
      return categoryMap[categoryValue] || '民用建筑'
    },
    getSubCategoryLabel(categoryValue, subCategoryValue) {
      // 这里可以根据实际需要添加子分类映射
      return '居住建筑'
    },
    getSubSubCategoryLabel(categoryValue, subCategoryValue, subSubCategoryValue) {
      // 这里可以根据实际需要添加子子分类映射
      return '商品住宅'
    },
    clearSelection() {
      this.$router.push('/costcases')
    },
    viewCaseDetail(caseItem) {
      this.$router.push({
        path: '/costcases/caseDetail',
        query: { id: caseItem.id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.case-list-container {
  width: var(--page-container-ratio, 70%);
  min-height: 100vh;
  padding: 20px;
  margin: 0 auto;
}

.breadcrumb-section {
  background: #fff;
  padding: 20px 30px;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    .breadcrumb-item {
      color: #0f6fe2;
    }

    .breadcrumb-separator {
      margin: 0 8px;
      color: #999;
    }
  }
}

.selected-conditions {
  background: #fff;
  padding: 20px 30px;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .condition-tag {
    display: inline-flex;
    align-items: center;
    background: #f0f8ff;
    border: 1px solid #0f6fe2;
    border-radius: 20px;
    padding: 8px 16px;
    font-size: 14px;
    color: #0f6fe2;

    .close-icon {
      margin-left: 8px;
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;

      &:hover {
        color: #ff4757;
      }
    }
  }
}

.case-list-button {
  background: #fff;
  padding: 20px 30px;
  margin-bottom: 20px;

  .case-list-btn {
    background: #0f6fe2;
    color: #fff;
    border: none;
    padding: 12px 24px;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
      background: #0c5bc7;
    }
  }
}

.cases-grid {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;

  .case-card {
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
    }

    .case-image {
      margin-bottom: 10px;

      .case-img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        border-radius: 6px;
      }
    }

    .case-title {
      font-size: 14px;
      color: #666;
      line-height: 1.4;
      text-align: center;
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .cases-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .case-list-container {
    padding: 10px;
  }

  .breadcrumb-section,
  .selected-conditions,
  .case-list-button {
    padding: 15px 20px;
  }

  .cases-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .cases-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}
</style>
